var DetailView;

DetailView = (function() {
  function DetailView() {
    Observable(this, 'asset');
    this.asset.subscribe(function() {
      return $('#detail').modal({
        show: true
      });
    });
  }

  return DetailView;

})();

//# sourceMappingURL=detail.js.map
